import { render, staticRenderFns } from "./CardsTypeInvestment.vue?vue&type=template&id=b800f336&scoped=true&"
import script from "./CardsTypeInvestment.vue?vue&type=script&lang=ts&"
export * from "./CardsTypeInvestment.vue?vue&type=script&lang=ts&"
import style0 from "./CardsTypeInvestment.vue?vue&type=style&index=0&id=b800f336&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b800f336",
  null
  
)

export default component.exports